import { Deserializable } from '../../protocols/deserializable';

export class MemberSIN implements Deserializable {
  public socialInsuranceNumber!: string;

  onDeserialize() {}
}
